import React from 'react';
import { Typography, Container, Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";

const useStyles = makeStyles(theme => ({
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: theme.spacing(1),
    },
}));

const EmployeeRow = ({ data }) => {
    const classes = useStyles();

    return (
        <>
        {!isMobile ?
            <Container className={classes.itemContainer}>
                <Grid item sm={2}>
                    <Typography variant="subtitle2">
                        {data.employeeID}
                    </Typography>
                </Grid>
                <Grid item sm={5}>
                    <Typography variant="subtitle2">
                    {data.lastName}, {data.firstName} 
                    </Typography>
                </Grid>
                <Grid item sm={4}>
                    <Typography variant="subtitle2">
                        {data.jobTitleName}
                    </Typography>
                </Grid>
                <Grid item sm={1}>
                    <Typography variant="subtitle2">
                        {data.businessUnitID}
                    </Typography>
                </Grid>
            </Container>
            :
            <>
                <Container className={classes.itemContainer}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {data.employeeID}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {data.firstName} {data.lastName}
                        </Typography>
                    </Grid>
                </Container>
                <Container className={classes.itemContainer}>
                    <Grid item xs={8}>
                        <Typography variant="subtitle2">
                            {data.jobTitleName}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="subtitle2">
                            {data.businessUnitID}
                        </Typography>
                    </Grid>
                </Container>
            </>
        }
        </>
    )
}

export default EmployeeRow;
